import {ComponentProps} from 'react';
import {twMerge} from 'tailwind-merge';

type LabelProps = ComponentProps<'label'> & {
  htmlFor: string;
};

function Label({className, htmlFor, children, ...props}: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={twMerge('cursor-pointer select-none text-base', className)}
      {...props}
    >
      {children}
    </label>
  );
}

export default Label;
